// Modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { NgxDnDModule } from '../dnd/ngx-dnd.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IDGSEnvironment, DGSCoreModule, DGSUICoreModule } from '@dotgov/z_core';
import { NgxPaginationModule } from 'ngx-pagination';

/// Bootstrap
import { TabsModule, TypeaheadModule, AccordionModule, BsDropdownModule, BsDatepickerModule } from 'ngx-bootstrap';
const ngxBbootstrap = [
  TypeaheadModule.forRoot(),
  AccordionModule.forRoot(),
  BsDropdownModule.forRoot(),
  BsDatepickerModule.forRoot(),
  TabsModule.forRoot(),
  NgxPaginationModule,
];

// Services
import { ToastrService } from 'ngx-toastr';
import { BuilderService } from '../dnd/services/builder.service';

// Components
import { FBFormTabComponent } from './components/FormTab/form-tab.component';
import { FBRendererComponent } from './components/renderer/renderer.component';
import { FBTextFieldComponent } from './components/controls/text-field/text-field.component';
import { ControlsSidebarComponent } from './components/controls-sidebar/controls-sidebar.component';
import { ControlPropertiesSidebarComponent } from './components/control-properties-sidebar/control-properties-sidebar.component';
import { FBLookupComponent } from './components/controls/lookup/lookup.component';
import { FBDateComponent } from './components/controls/date/date.component';
import { FBCheckBoxComponent } from './components/controls/check-box/check-box.component';
import { FBControlsHTMLContentComponent } from './components/controls/html-content/html-content.component';
import { FBControlsListFieldComponent } from './components/controls/list-field/list-field.component';
import { FBDateTimeComponent } from './components/controls/date-time/date-time.component';
import { FBControlsCustomControlComponent } from './components/controls/editable-grid/editable-grid.component';
import { FBControlsProgressBarComponent } from './components/controls/progress-bar/progress-bar.component';
import { FBControlsRadioButtonComponent } from './components/controls/radio-button/radio-button.component';
import { FBControlsNumberFieldComponent } from './components/controls/number-field/number-field.component';
import { FBControlsUploadFileComponent } from './components/controls/upload-file/upload-file.component';
import { FBControlsToggleComponent } from './components/controls/toggle/toggle.component';

// Models
import { ENVIRONMENT_NAME } from './../constants';
import { environment } from '../../environments/environment';

const formControls = [
  FBTextFieldComponent,
  FBLookupComponent,
  FBDateComponent,
  FBCheckBoxComponent,
  FBControlsHTMLContentComponent,
  FBControlsListFieldComponent,
  FBDateTimeComponent,
  FBControlsCustomControlComponent,
  FBControlsProgressBarComponent,
  FBControlsRadioButtonComponent,
  FBControlsToggleComponent,
  FBControlsUploadFileComponent,
  FBControlsNumberFieldComponent,
];

@NgModule({
  declarations: [FBRendererComponent, FBFormTabComponent, ControlsSidebarComponent, ControlPropertiesSidebarComponent, ...formControls],
  imports: [CommonModule, NgxDnDModule, FormsModule, DGSUICoreModule, DGSCoreModule, ...ngxBbootstrap],
  providers: [ToastrService, BuilderService],
  exports: [FBRendererComponent, ...formControls],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormBuilderModule {
  public static forRoot(_enviroment: IDGSEnvironment): ModuleWithProviders {
    return {
      ngModule: FormBuilderModule,
      providers: [
        BuilderService,
        DGSCoreModule.forRoot(_enviroment).providers,
        { provide: 'enviroment', useValue: _enviroment || environment[ENVIRONMENT_NAME] },
      ],
    };
  }
}
